import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

const PREFIXO = 'dashboard';

export const verificarExistenciaDeMarca = async (params) => {
  const url = `/${PREFIXO}/pedidos-pendentes/verificar-existencia-de-marca`;

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;

  return data.status;
}

export const buscarMarca = async (params) => {
  const url = `/${PREFIXO}/pedidos-pendentes/buscar-marca`;

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;

  return data.marcas;
}
export const buscarFornecedor = async (params) => {
  const url = `/${PREFIXO}/pedidos-pendentes/buscar-fornecedor`;

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;

  return data.fornecedores;
}

export const buscarPedidosFornecedor = async (params) => {
  const url = `/${PREFIXO}/pedidos-pendentes/buscar-pedidos-fornecedor`;

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;

  return data.pedidos;
}

export const buscarProdutosPedidosFornecedor = async (params) => {
  const url = `/${PREFIXO}/pedidos-pendentes/buscar-produtos-pedidos-fornecedor`;

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;

  return data.produtos;
}